import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfitCenterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ProfitCenterCreateDto,
  ProfitCenterDto,
  ProfitCenterExcelDownloadDto,
  ProfitCenterUpdateDto,
} from '../proxy/controlling/dtos/profit-center';
import { PROFITCENTER_CONFIG, PROFITCENTER_FIELDS } from './profit-center.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-profit-center',
  imports: [
    CommonModule,
    ZnHierarchicalViewComponent,
    GenericForm,
  ],
  providers: [ListService, ProfitCenterService, ConfirmationService],
  templateUrl: './profit-center.html',
  styleUrl: './profit-center.scss',
})
export class ProfitCenter extends BaseHierarchicalCrudComponent<
  ProfitCenterDto,
  ProfitCenterCreateDto,
  ProfitCenterUpdateDto,
  ProfitCenterExcelDownloadDto
> {
  service = inject(ProfitCenterService);
  config = PROFITCENTER_CONFIG;
  fields = PROFITCENTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: ProfitCenterDto): ProfitCenterUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ProfitCenter';
  }
}
